export const LOCAL_STORAGE_KEYS = {
  HOST: "studio-api-host"
}
